export default "__VITE_ASSET__BruJbgVv__"